import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private fireStore : AngularFirestore) { }


  fetchUsers(){
    return this.fireStore.collection('users').get();
   }


   setData(uid){
    return this.fireStore.collection('users').doc(uid);
    }



}
